export const RELATIONSHIP_TYPES = {
    DIRECT_REPORT: "direct_report",
    MANAGER: "manager",
    PEER: "peer",
    SKIP_LEVEL: "skip_level",
    OTHER: "other",
};

export const RELATIONSHIP_LABELS = {
    [RELATIONSHIP_TYPES.DIRECT_REPORT]: "Reports to me",
    [RELATIONSHIP_TYPES.MANAGER]: "Manager",
    [RELATIONSHIP_TYPES.PEER]: "Peer",
    [RELATIONSHIP_TYPES.SKIP_LEVEL]: "Skip Level",
    [RELATIONSHIP_TYPES.OTHER]: "Other",
};

export const RELATIONSHIP_OPTIONS_ALL = [
    { value: RELATIONSHIP_TYPES.MANAGER, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.MANAGER] },
    { value: RELATIONSHIP_TYPES.PEER, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.PEER] },
    { value: RELATIONSHIP_TYPES.DIRECT_REPORT, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.DIRECT_REPORT] },
    { value: RELATIONSHIP_TYPES.SKIP_LEVEL, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.SKIP_LEVEL] },
    { value: RELATIONSHIP_TYPES.OTHER, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.OTHER] },
];

export const RELATIONSHIP_OPTIONS_MANAGER_ONLY = [
    { value: RELATIONSHIP_TYPES.MANAGER, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.MANAGER] },
    { value: RELATIONSHIP_TYPES.SKIP_LEVEL, label: RELATIONSHIP_LABELS[RELATIONSHIP_TYPES.SKIP_LEVEL] },
];

export const DOCUMENT_UPLOAD_TYPES = {
    EXISTING_DOCUMENT: "existing_document",
    PAST_REVIEW: "past_review",
    GOALS: "goals",
    OTHER: "other",
};

export const REVIEW_TYPES = {
    SELF: "self",
    CONNECTIONS: "connections",
};

export const PERFORMANCE_REVIEW_EVENT_PREFIX = "performance_review_";
